


















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CheckedGreen extends Vue {
  @Prop({ default: '16' }) size!: string;
  @Prop({ default: '#20AB63' }) fillColor!: string;
  @Prop({ default: '#fff' }) strokeColor!: string;
}
